import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Trigger} from '@models/adminstration/machine/trigger/trigger';
import {Role} from '@models/user/role';
import {User} from '@models/user/user';
import {TriggerHelperService} from '@services/trigger/helper/trigger-helper.service';

@Component({
    selector: 'scitis-trigger-query-action',
    templateUrl: './trigger-query-action.component.html',
    styleUrls: ['./trigger-query-action.component.scss'],
    standalone: false
})
export class TriggerQueryActionComponent implements OnInit {

  @Input()
  public trigger: Trigger = new Trigger();

  @Input()
  public userRole: Role = new Role(new User());

  @Output()
  public deleteTrigger: EventEmitter<Trigger> = new EventEmitter<Trigger>();

  @Output()
  public updateTrigger: EventEmitter<Trigger> = new EventEmitter<Trigger>();

  public deleteButtonIsEnabled: boolean = false;
  editButtonIsDisabled: any;

  constructor(
    private triggerHelperService: TriggerHelperService
  ) { }

  ngOnInit(): void {
    this.setDeleteButtonIsEnabled();
  }

  public onDeleteTriggerQuery(): void {
    this.deleteTrigger.emit(this.trigger);
  }

  public onEditTriggerQuery(): void {
    this.updateTrigger.emit(this.trigger);
  }

  private setDeleteButtonIsEnabled(): void {
    this.deleteButtonIsEnabled = this.triggerHelperService.setDeleteButtonIsEnabled(this.trigger, this.userRole);
  }
}
